<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span
          >{{ method === "post" ? "Add" : "Edit" }} Instant transfer country fee configuration</span
        >
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :fields="feeConfiguration"
          :method="method"
          :action="url"
          @submitted="$emit('changed', $event)"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-select
                  name="country_id"
                  :items="countries"
                  item-text="name"
                  item-value="id"
                  label="Country"
                />
              </v-col>
              <v-col cols="12">
                <custom-select
                  name="fee_type_id"
                  class="form-group"
                  label="Fees Type"
                  :items="transactionFeesTypes"
              /></v-col>
              <v-col cols="12">
                <custom-input label="Spread" name="spread" />
              </v-col>
              <v-col cols="12">
                <custom-button block color="primary">
                  <v-icon v-if="method === 'post'">mdi-plus</v-icon>
                  <v-icon v-else>mdi-pencil</v-icon>
                  {{ method === "post" ? "Add" : "Edit" }}
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import Countries from "../../../platformConfigurations/transactionCountries/loadCountries";

export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    feeConfiguration: {
      default: () => {},
      type: Object,
    },
  },
  mixins: [Countries],
  data() {
    return {
      feeTypes: [],
      key: 1,
      receivingCountries: [],
      cashInMethods: [],
    };
  },
  watch: {
    isActive() {
      this.key++;
    },
  },
  created() {
    this.fetchData();
    this.loadCountries();
  },
  computed: {
    transactionFeesTypes() {
      return this.getSelectOptions(this.feeTypes);
    },
    transactionCashInMethods() {
      return this.getSelectOptions(this.cashInMethods);
    },

    url() {
      if (this.feeConfiguration && this.feeConfiguration.id) {
        return `api/v1/transactions/feeConfigurations/${this.feeConfiguration.fee_configuration_id}/countryTransfer/${this.feeConfiguration.id}`;
      }
      return `api/v1/transactions/feeConfigurations/${this.$route.params.id}/countryTransfer`;
    },
  },
  methods: {
    updateReceivingCountries(id) {
      this.$http.get(`/api/v1/transactions/transferCountries/${id}`).then((data) => {
        this.receivingCountries = data.receiving_countries;
      });
    },
    getSelectOptions(data) {
      return data.map(({ id, name }) => ({ value: id, text: name }));
    },
    fetchData() {
      this.$http.get("/api/v1/transactions/feeTypes").then((types) => {
        this.feeTypes = types.data;
      });
      this.$http.get(`/api/v1/transactions/transferCashInMethods/all`).then((data) => {
        this.cashInMethods = data;
      });
    },
  },
};
</script>
